<template>
  <div class="error-page">
    <div class="error-container">
      <div class="error-icon">
        <i class="fas fa-exclamation-triangle"></i>
      </div>
      <h1 class="error-title">{{ errorTitle }}</h1>
      <p class="error-message">{{ errorMessage }}</p>
      <div class="error-actions">
        <button @click="goHome" class="btn btn-primary">
          <i class="fas fa-home"></i> Go Home
        </button>
        <button @click="goBack" class="btn btn-secondary">
          <i class="fas fa-arrow-left"></i> Go Back
        </button>
        <button @click="reload" class="btn btn-tertiary">
          <i class="fas fa-redo"></i> Reload Page
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorPage',
  props: {
    errorCode: {
      type: [String, Number],
      default: '500'
    },
    errorTitle: {
      type: String,
      default: 'Something went wrong'
    },
    errorMessage: {
      type: String,
      default: 'An unexpected error occurred. Please try again or contact support if the problem persists.'
    }
  },
  methods: {
    goHome() {
      this.$router.push('/');
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push('/');
      }
    },
    reload() {
      window.location.reload();
    }
  }
};
</script>

<style scoped>
.error-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 2rem;
}

.error-container {
  text-align: center;
  max-width: 600px;
  color: white;
}

.error-icon {
  font-size: 4rem;
  margin-bottom: 1.5rem;
  color: #ffeb3b;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
}

.error-title {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
}

.error-message {
  font-size: 1.2rem;
  line-height: 1.6;
  margin-bottom: 2rem;
  opacity: 0.9;
}

.error-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
}

.btn {
  padding: 12px 24px;
  border: none;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.btn-primary {
  background: rgba(255,255,255,0.2);
  color: white;
  border: 2px solid rgba(255,255,255,0.3);
}

.btn-primary:hover {
  background: rgba(255,255,255,0.3);
  border-color: rgba(255,255,255,0.5);
  transform: translateY(-2px);
}

.btn-secondary {
  background: rgba(0,0,0,0.2);
  color: white;
  border: 2px solid rgba(255,255,255,0.2);
}

.btn-secondary:hover {
  background: rgba(0,0,0,0.3);
  border-color: rgba(255,255,255,0.4);
  transform: translateY(-2px);
}

.btn-tertiary {
  background: transparent;
  color: white;
  border: 2px solid rgba(255,255,255,0.3);
}

.btn-tertiary:hover {
  background: rgba(255,255,255,0.1);
  border-color: rgba(255,255,255,0.5);
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .error-container {
    padding: 1rem;
  }
  
  .error-title {
    font-size: 2rem;
  }
  
  .error-message {
    font-size: 1rem;
  }
  
  .error-actions {
    flex-direction: column;
    align-items: center;
  }
  
  .btn {
    width: 200px;
    justify-content: center;
  }
}
</style>